import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { Category } from '../../shared/category.model';
import { CategoryService } from '../../shared/category.service';

@Component({
  selector: 'app-category-translation-modal',
  templateUrl: './category-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CategoryTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private categoryService: CategoryService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<CategoryTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getCategory();
  }

  category: Category = null;
  categoryCopy = null;

  modalTitle = this.data.title;
  categoryId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedCategoryTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    if (!fields.some((field) => formData[field] !== this.categoryCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.categoryService.saveCategory(this.category.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getCategory() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.categoryService.getCategory(this.categoryId, params).subscribe((category) => {
      this.category = category;
      this.categoryCopy = { ...this.category };

      this.setCategoryTranslationForm();

      this.form.patchValue(this.category);
    });
  }

  private setCategoryTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), // use it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*


const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.category.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), // use it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.category.description],
    });



*/
